export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail ou nome de usuário',
      invalidEmailOrUsername: 'E-mail ou nome de usuário inválido',
      invalidPassword: 'Senha inválida',
      noInternetConnection: 'Sem conexão com a internet',
      pageNotFound_title: 'Página não encontrada',
      password: 'Senha',
      projectManagement: 'Gerenciamento de projetos',
      serverConnectionFailed: 'Falha na conexão com o servidor',
      unknownError: 'Erro desconhecido, tente novamente mais tarde',
      useSingleSignOn: 'Usar login único',
    },

    action: {
      logIn: 'Entrar',
      logInWithSSO: 'Entrar com SSO',
    },
  },
};
